'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function NLFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-92tow84xv", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-v222asx91", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-lkcsb2z21" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-lkcsb2z21", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-92tow84xv)" }, /* @__PURE__ */ React.createElement("use", { fill: "#f7fcff", xlinkHref: "#mantine-lkcsb2z21" }), /* @__PURE__ */ React.createElement("path", { fill: "#e31d1c", d: "M0 0h32v8H0z", mask: "url(#mantine-v222asx91)" }), /* @__PURE__ */ React.createElement("path", { fill: "#3d58db", d: "M0 16h32v8H0z", mask: "url(#mantine-v222asx91)" })))
  );
}

export { NLFlag };
//# sourceMappingURL=NL.mjs.map
